// extracted by mini-css-extract-plugin
export default {"root":"HallControls_root__-oVYH","reset":"HallControls_reset__cEdqC","button":"HallControls_button__WHbJi"};